// extracted by mini-css-extract-plugin
module.exports = {"root":"Questions_root__24bOA"};